// Theme: system (the default), light or dark. data-theme on <html> forces one; .is-dark mirrors the result
// for the site's own CSS. The avatars follow the page on their own (the package reads data-theme and color-scheme).
import { useEffect, useState } from 'react';

export type ThemeChoice = 'system' | 'light' | 'dark';
const KEY = 'agent-avatar-studio:theme:v2';
const root = () => document.documentElement;
const mq = () => window.matchMedia('(prefers-color-scheme: dark)');

export function themeChoice(): ThemeChoice {
  const t = root().getAttribute('data-theme');
  return t === 'light' || t === 'dark' ? t : 'system';
}
export const isDark = () => { const t = themeChoice(); return t === 'system' ? mq().matches : t === 'dark'; };
export function setTheme(t: ThemeChoice) {
  if (t === 'system') root().removeAttribute('data-theme'); else root().setAttribute('data-theme', t);
  try { localStorage.setItem(KEY, t); } catch { /* the switch still works for this visit */ }
  syncDark();
}
export function syncDark() { root().classList.toggle('is-dark', isDark()); }

/** The current choice and whether the page is dark, kept in step with the system setting. */
export function useTheme(): [ThemeChoice, boolean, (t: ThemeChoice) => void] {
  const [, force] = useState(0);
  useEffect(() => {
    syncDark();
    const m = mq(), on = () => { syncDark(); force(n => n + 1); };
    m.addEventListener('change', on);
    return () => m.removeEventListener('change', on);
  }, []);
  return [themeChoice(), isDark(), t => { setTheme(t); force(n => n + 1); }];
}
